import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gs76e6ynfc: FaireBrandEntity = {
  token: "b_gs76e6ynfc",
  type: "brand",
  name: "CopperCulture",
  avatarUrl:
    "https://cdn.faire.com/fastly/91b2370fe4c51e20be4269072f42bad376f22e515e8b803187eaab833c7e1b3a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/486061550a11edade42b808a4dba2831d3e8988d3c2b929540fb8427e124804d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/91b2370fe4c51e20be4269072f42bad376f22e515e8b803187eaab833c7e1b3a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/486061550a11edade42b808a4dba2831d3e8988d3c2b929540fb8427e124804d.jpeg",
  location: "AUS",
  minimumOrderDollars: 90,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Copper Culture was born when a shared passion for entrepreneurship and humanitarianism met the wisdom of ancient wellness. As a couple, we sought a remedy for our modern fatigue and rediscovered an age-old tradition—drinking from pure copper. What started as a simple lifestyle change soon became something greater. The energy, balance, and vitality we experienced felt too valuable to keep to ourselves.\n\nFrom a single WhatsApp conversation to a thriving vision, Copper Culture emerged with a mission: to blend time-honoured wellness with sustainable craftsmanship. Each of our handcrafted copper bottles is carefully created with dedication and precision, shaped by skilled artisans in the heart of India. Beyond hydration, they carry a legacy—one of purity, longevity, and respect for nature’s gifts.\n\nChoosing Copper Culture is more than an investment in health. It’s a commitment to sustainability, supporting craftsmanship, and the harmony of mind, body, and soul. With every sip, you embrace the wisdom of the past while making a conscious choice for the future.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:33.591Z",
    importedBy: "entity-db-cli",
  },
};
